import { Injectable, Type } from '@angular/core';
import { IQuestionnaireGroup, Messgeraete } from '@interfaces/interfaces';
import { SpecialQuestionItem, SpecialQuestionType } from '@interfaces/questions';
import { WizardPage } from '@workflow/components/navigator/wizard-view/interfaces';
import {
	ISpecialQuestion,
	ISpecialQuestionComponent
} from '@workflow/components/questionnaire/questionnaire-item/special-question/special-question.service';

@Injectable({
	providedIn: 'root',
})
export abstract class AbstractReaktion implements ISpecialQuestion {
	readonly COUNT: number;
	readonly prologueFullHeight: boolean | undefined;

	constructor() {
	}

	abstract component: Type<ISpecialQuestionComponent>;
	abstract defaultGroupConfiguration: IQuestionnaireGroup;
	abstract requiredDevices: Messgeraete[];
	abstract specialQuestionType: SpecialQuestionType;

	abstract buildWizardPages(group: IQuestionnaireGroup, specialQuestion: SpecialQuestionItem, groupIndex: number, currentValue: unknown): WizardPage[];

	isCompleted(currentValue: {[key: number]: number}): boolean {
		if ( !currentValue || Object.keys(currentValue).length !== this.COUNT) {
			return false;
		}
		for (let i = 0; i < this.COUNT; i++) {
			if (typeof currentValue[i] !== 'number' || Number.isNaN(currentValue[i])) {
				return false;
			}
		}
		return true;
	}

}
